import { Component, OnInit, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OregonWellDataService } from '../../../services/oregon-well-data.service';
import { ISearchResult } from 'app/models/well/search/search.result';
import { SharedService } from '@shared/services/shared.service';

/*
 * Merge Well Dialog
 */
@Component({
    selector: 'dialog-merge-wells',
    templateUrl: 'merge-wells.html',
    styleUrls: ['./merge-wells.scss']
  })
  export class DialogMergeWellsComponent implements OnInit  {
    loading: boolean = false;
    merging: boolean = false;
    displayedColumns: string[] = ['action','id', 'address', 'city', 'state', 'zip', 'county'];
    selectedWellId: number = 0;
  
    
    constructor(public retwellService: OregonWellDataService, 
                private toastr: ToastrService, 
                @Inject(MAT_DIALOG_DATA) public data: ISearchResult[],
                private sharedService: SharedService,
                private dialogRef: MatDialogRef<DialogMergeWellsComponent>) {
    }

    ngOnInit(): void {      
      // ngOnInit   
    }

    onChangeSelectedWell(wellId: number) {
        this.selectedWellId = wellId;
    }

    merge() 
    {      
        this.sharedService.openConfirm("Are you sure you want to perform this merge?");
        this.sharedService.confirmed().subscribe( confirmed => {
          if(confirmed) {        
            this.merging = true;
            let wellsNotSelected = this.data.filter(w => w.wellId !== this.selectedWellId.toString()).map(m => m.wellId);
            this.retwellService.Merge(this.selectedWellId, wellsNotSelected).subscribe(result => {
                    this.merging = false;
                    this.toastr.success('Merge successful');
                    this.dialogRef.close();
                  }, error => {
                    this.merging = false;
                  });
          }
        });
       
    }  
  
  }